module.exports = __webpack_public_path__ + "fonts/Colfax-Regular.106de158.otf";